import React from 'react';

// Modal con el estilo del panel de la cuenta particular (mismas clases que el Modal de ParticularDashboard).
const ParticularModal = ({ title, icon, children, onClose, className = '' }) => (
  <div className="particular-modal-overlay" onMouseDown={onClose}>
    <div className={`particular-modal ${className}`.trim()} onMouseDown={(event) => event.stopPropagation()}>
      <div className="particular-modal-header">
        <h3>
          <i className={icon} />
          {title}
        </h3>
        <button type="button" onClick={onClose} title="Cerrar">
          <i className="fas fa-times" />
        </button>
      </div>
      {children}
    </div>
  </div>
);

export default ParticularModal;
